const TOKEN_KEY = 'token';

const canUseStorage = () => typeof window !== 'undefined';

export const getAuthToken = () => {
    if (!canUseStorage()) {
        return null;
    }

    const sessionToken = window.sessionStorage.getItem(TOKEN_KEY);
    if (sessionToken) {
        return sessionToken;
    }

    // Legacy migration: move persisted token into session scope.
    const legacyToken = window.localStorage.getItem(TOKEN_KEY);
    if (legacyToken) {
        window.sessionStorage.setItem(TOKEN_KEY, legacyToken);
        window.localStorage.removeItem(TOKEN_KEY);
        return legacyToken;
    }

    return null;
};

export const setAuthToken = (token) => {
    if (!canUseStorage()) {
        return;
    }

    if (token) {
        window.sessionStorage.setItem(TOKEN_KEY, token);
        window.localStorage.removeItem(TOKEN_KEY);
        return;
    }

    window.sessionStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(TOKEN_KEY);
};

export const removeAuthToken = () => {
    if (!canUseStorage()) {
        return;
    }

    window.sessionStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(TOKEN_KEY);
};

export const hasAuthToken = () => !!getAuthToken();
